
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1sxt8_14983_13",
  "drawer": "awsui_drawer_1sxt8_14983_17",
  "has-close-action": "awsui_has-close-action_1sxt8_14983_50",
  "position-absolute": "awsui_position-absolute_1sxt8_14983_53",
  "placement-end": "awsui_placement-end_1sxt8_14983_53",
  "position-sticky": "awsui_position-sticky_1sxt8_14983_53",
  "position-fixed": "awsui_position-fixed_1sxt8_14983_53",
  "placement-start": "awsui_placement-start_1sxt8_14983_56",
  "placement-top": "awsui_placement-top_1sxt8_14983_59",
  "placement-bottom": "awsui_placement-bottom_1sxt8_14983_62",
  "with-footer": "awsui_with-footer_1sxt8_14983_65",
  "position-static": "awsui_position-static_1sxt8_14983_69",
  "content": "awsui_content_1sxt8_14983_72",
  "header": "awsui_header_1sxt8_14983_100",
  "hide-close-action": "awsui_hide-close-action_1sxt8_14983_116",
  "with-additional-action": "awsui_with-additional-action_1sxt8_14983_120",
  "with-runtime-context": "awsui_with-runtime-context_1sxt8_14983_128",
  "with-toolbar": "awsui_with-toolbar_1sxt8_14983_131",
  "header-actions": "awsui_header-actions_1sxt8_14983_150",
  "close-action": "awsui_close-action_1sxt8_14983_156",
  "content-with-paddings": "awsui_content-with-paddings_1sxt8_14983_162",
  "footer": "awsui_footer_1sxt8_14983_169",
  "is-sticky": "awsui_is-sticky_1sxt8_14983_175",
  "test-utils-drawer-content": "awsui_test-utils-drawer-content_1sxt8_14983_183",
  "hidden": "awsui_hidden_1sxt8_14983_187",
  "focus-trap": "awsui_focus-trap_1sxt8_14983_191",
  "backdrop": "awsui_backdrop_1sxt8_14983_195",
  "backdrop-fixed": "awsui_backdrop-fixed_1sxt8_14983_199",
  "backdrop-absolute": "awsui_backdrop-absolute_1sxt8_14983_202"
};
  